'use client';

import styled from 'styled-components';

import { Sizes, Spacers } from '@styles/theme';

export const ProfileContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${Spacers.BASE}rem;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${Spacers.LG}rem;
  border-radius: ${Spacers.XS}rem;
  border: ${(props) => `1px solid ${props.theme.colors.backgroundAccent}`};
  padding: ${Spacers.BASE}rem;
  color: ${({ theme }) => theme.colors.typographyBodyLight};
`;

export const PhotoContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${Spacers.BASE}rem;
`;

export const ImageContainer = styled.div`
  border-radius: ${Spacers.XS}rem;
  width: ${Sizes.PROFILE_IMAGE};
  height: ${Sizes.PROFILE_IMAGE};
`;

export const TitleInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.BASE}rem;
  color: ${({ theme }) => theme.colors.typographyBodyLight};
`;

export const ProfileInfoTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-weight: ${({ theme }) => theme.typography.title.fontWeight};
  line-height: ${({ theme }) => theme.typography.title.lineHeight};
`;

export const ActionContainer = styled.div`
  display: flex;
  gap: ${Spacers.XS}rem;
`;
